import { useBackend } from "../../services";
import { useEffect, useState } from "react";
import { StatusCodesHelper } from "../../models/StatusCodesHelper";
import { DataStorage } from "../../models/DataStorage";

export const useGetHighlightedAlbums = <T>(
  setLoading: (loading: boolean) => void,
  dependencies: T[] = []
) => {
  const { get } = useBackend();
  const storage = DataStorage.highlightedAlbumStorage;
  const [highlightedAlbums, setHighlightedAlbums] = useState(storage.getData(true, ""));
  useEffect(() => {
    if (highlightedAlbums && highlightedAlbums.length > 0) return;
    setLoading(true);
    get("albums/shared/highlights").then(({ body, status }) => {
      if (StatusCodesHelper.isSuccessful(status)) {
        setHighlightedAlbums(body);
        storage.setData(body, true, "");
      }
      setLoading(false);
    });
  }, dependencies);
  return highlightedAlbums;
};
